export const TITLE = `רוצים שנציג יצור עמכם קשר?`

export const SUB_TITLE = `השאירו פרטים ונחזור אליכם בהקדם`